import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Backdrop,
  LinearProgress,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { generateOtp } from "../../redux/action/otp";

const ConsumerLogin = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { businessName,carrierCanonicalId } = useParams();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const handleSubmit = async () => {
    if (!email) {
      setError("email is required");
      return;
    }
    if (!carrierCanonicalId) {
      setError("Carrier ID is missing");
      return;
    }
    setLoadingMessage("Sending OTP...");
    setIsLoading(true);
    setError("");
    try {
      await dispatch<any>(generateOtp({email, carrierCanonicalId })).unwrap();
      localStorage.setItem("userEmail", email);
      navigate(`/${businessName}/${carrierCanonicalId}/otp-verification`, {
        state: { email },
      });
    } catch (error: any) {
      setError(error || "Failed to send OTP");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Box
        sx={{
          width: "100%",
          minHeight: "100vh",
          height: "100%",
          background:
            "linear-gradient(-45deg, #ee7752, #e73c7e, #23d5ab, #23a6d5)",
          backgroundSize: "400% 400%",
          animation: "gradientAnimation 20s ease infinite",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          p: isMobile ? 1 : 3,
          overflow: "hidden",
          boxSizing: "border-box",
        }}
      >
        <Box
          sx={{ p: 3, maxWidth: "500px", margin: "0 auto", textAlign: "center" }}
        >
          {isLoading && (
            <Backdrop
              sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={isLoading}
              onClick={() => {
                setIsLoading(true);
              }}
            >
              <Box sx={{ width: "50%" }}>
                <LinearProgress />
                <Typography
                  fontSize={16}
                  fontWeight={500}
                  textAlign="center"
                  mt={1}
                >
                  {loadingMessage}
                </Typography>
              </Box>
            </Backdrop>
          )}

          <Typography variant="h4" gutterBottom>
            Login
          </Typography>

          <TextField
            fullWidth
            label="Enter Email"
            variant="outlined"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            sx={{ mb: 2 }}
          />

          {error && (
            <Typography color="error" sx={{ mb: 2 }}>
              {error}
            </Typography>
          )}

          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            sx={{ width: "100%" }}
          >
            Send OTP
          </Button>
        </Box>
      </Box>
      <style>
        {`
          @keyframes gradientAnimation {
            0% {
              background-position: 0% 50%;
            }
            50% {
              background-position: 100% 50%;
            }
            100% {
              background-position: 0% 50%;
            }
          }
        `}
      </style>
    </>
  );
};

export default ConsumerLogin;
